import React, { useState, useEffect, HTMLAttributes } from 'react';
import { Label } from 'scorer-ui-kit';
import { SelectField } from '../Style';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const IntervalLabel = styled(Label)`
  padding-top: 12px;
  margin-right: 10px;
`;

const RefreshContainer = styled.div`
    display: flex;
`;

interface OwnProps {
    pageName: string,
    autoRefresh: any
}
type Props = OwnProps & HTMLAttributes<HTMLDivElement>;

const AutoRefresh = (props: OwnProps) => {
  const { pageName, autoRefresh } = props;
  const localStorageName = pageName + '_refresh_interval';
  const [refreshInterval, setRefreshInterval] = useState<string>(localStorage.getItem(localStorageName) || '0');
  const [intervalId, setIntervalId] = useState<number>(0);
  const { t } = useTranslation(['Common']);

  const RefreshIntervals = [
    { 'name': 'none', 'value': '0' },
    { 'name': '15'+t('seconds'), 'value': '15' },
    { 'name': '30'+t('seconds'), 'value': '30' },
    { 'name': '45'+t('seconds'), 'value': '45' },
    { 'name': '60'+t('seconds'), 'value': '60' }];

  useEffect(() => {
    refreshPage(refreshInterval);
    // eslint-disable-next-line 
  }, []);

  function refreshPage(refInterval: string) {
    if (refInterval !== '0') {

      const interval = setInterval(() => {
        autoRefresh();
      }, parseInt(refInterval || '0') * 1000);

      setIntervalId(interval);

      return () => {
        clearInterval(interval);
      };
    }
  }

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    clearInterval(intervalId);
    setRefreshInterval(event.target.value);
    localStorage.setItem(localStorageName, event.target.value);
    refreshPage(event.target.value);
  };

  return (
    <RefreshContainer {...props}>
      <IntervalLabel htmlFor='' labelText={t('refreshInterval')} />
      <SelectField name='refreshInterval' defaultValue={refreshInterval} onChange={handleOnChange}>
        {
          RefreshIntervals.map(({ name, value }) =>
            <option key={value} value={value}>{t(name)}</option>
          )
        }
      </SelectField>
    </RefreshContainer>
  );
};

export default AutoRefresh;
